import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { NoValue } from '../../../sharedComponents/NoValue';

export const SPECIAL_INSTRUCTIONS_PREVIEW_LENGTH = 40;

type DisplaySpecialInstructionsProps = {
    readonly specialInstructions: readonly string[];
};

export const DisplaySpecialInstructions = ({ specialInstructions }: DisplaySpecialInstructionsProps) => {
    const text = specialInstructions.join(' ').trim();

    if (text.length === 0) {
        return <NoValue />;
    }

    const isTruncated = text.length > SPECIAL_INSTRUCTIONS_PREVIEW_LENGTH;
    const preview = isTruncated ? `${text.slice(0, SPECIAL_INSTRUCTIONS_PREVIEW_LENGTH).trimEnd()}` : text;
    const content = <span className="display-block ellipsis-1">{preview}</span>;

    if (!isTruncated) {
        return content;
    }

    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip
                    id="special-instructions-tooltip"
                    textAlignment="left"
                    width="auto"
                    innerClassName="max-width-500"
                >
                    {specialInstructions.map((specialInstruction, index) => (
                        <div key={`${specialInstruction}-${index}`}>{specialInstruction}</div>
                    ))}
                </Tooltip>
            }
        >
            {content}
        </OverlayTrigger>
    );
};
